export default "__VITE_ASSET__aff63d29__"